import { jsx, jsxs } from "react/jsx-runtime";
import "../../../constants/index.js";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import List from "../../data-display/List/List.js";
import Checkbox from "../../inputs/Checkbox/Checkbox.js";
const SelectOptions = ({
  classes,
  className,
  selectedOption,
  options,
  handleOnSelect,
  imageVariant
}) => {
  const { themeClasses } = useThemePresetClasses("SelectOptions", classes, className, {
    variant: imageVariant
  });
  return /* @__PURE__ */ jsx(List, { className: cn(themeClasses == null ? void 0 : themeClasses.root), children: options.map((option) => {
    const { id, imgUrl, name } = option;
    const isChecked = (selectedOption == null ? void 0 : selectedOption.id) === option.id;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        onClick: () => handleOnSelect(option),
        className: `flex w-full items-center p-4 first:rounded-t-md last:rounded-b-md`,
        children: [
          imgUrl && /* @__PURE__ */ jsx(
            "img",
            {
              src: imgUrl,
              alt: name,
              className: cn(themeClasses == null ? void 0 : themeClasses.image)
            }
          ),
          name && /* @__PURE__ */ jsx("span", { className: cn("text-content-base ml-3 text-base"), children: name }),
          /* @__PURE__ */ jsx(
            Checkbox,
            {
              checked: isChecked,
              onChange: () => handleOnSelect(option),
              className: `ml-auto`,
              variant: "filled"
            }
          )
        ]
      },
      id
    );
  }) });
};
const SelectOptions$1 = SelectOptions;
export {
  SelectOptions$1 as default
};
